import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

const EditAdminProfile = ({ show, firstName, lastName, copiedCredentials, handleChange, onSave, onHide }) => {
  const obj = { firstName: firstName, lastName: lastName }
  const compare = JSON.stringify(obj) === JSON.stringify(copiedCredentials)
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Edit Admin Profile</Modal.Title>
      </Modal.Header>
      <Form>
        <Modal.Body>
          <Form.Group className="mb-3" controlId="formFirstName" onSubmit={onSave}>
            <Form.Label>First Name</Form.Label>
            <Form.Control
              type="text"
              name="firstName"
              value={firstName}
              onChange={handleChange}
              placeholder="Enter first name"
              required
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="formLastName">
            <Form.Label>Last Name</Form.Label>
            <Form.Control
              type="text"
              name="lastName"
              value={lastName}
              onChange={handleChange}
              placeholder="Enter last name"
              required
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            Cancel
          </Button>
          <Button variant="primary" type="submit" onClick={onSave} disabled={compare}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default React.memo(EditAdminProfile);